import { useMemo, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { Menu } from "antd";
import { fetchCall, url } from "../constants/constant";
import {
  FaWarehouse, FaUserAlt, FaLock, FaUserLock, FaUserTie,
  FaMoneyBillWave, FaChartLine, FaBuilding, FaMoneyCheck, FaWhatsapp, FaList, FaBell,
} from "react-icons/fa";
import {
  MdSettings, MdOutlineInventory, MdPeopleAlt,
} from "react-icons/md";
import {
  RiRefund2Line, RiFolderUserFill, RiFolderLockFill,
} from "react-icons/ri";
import { AiFillSetting, AiFillFile } from "react-icons/ai";
import { BiCategoryAlt } from "react-icons/bi";
import { IoIosPeople } from "react-icons/io";
import { VscNewFile } from "react-icons/vsc";
import { GiPayMoney } from "react-icons/gi";
import { TbFileBarcode } from "react-icons/tb";
import { HiChartBar, HiChartPie, HiDocumentAdd, HiDocumentText } from "react-icons/hi";
import { FaFileInvoiceDollar } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const iconSize = 16;
const iconStyle = { fontSize: iconSize, marginRight: 12 };

const MobileMenu = ({ permission, user, integrationConfig, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [logoImage, setLogoImage] = useState("");

  useEffect(() => {
    fetchCall(
      `${url.getImage}mobile_logo_image`,
      (data) => setLogoImage(data.items?.mobile_logo_image || ""),
      () => {},
      "GET"
    );
  }, []);

  const nav = (path) => () => {
    navigate(path);
    onClose?.();
  };

  const menuItems = useMemo(() => {
    const items = [];

    if (permission.view_product || permission.view_category || user.is_admin) {
      const children = [];
      if (permission.view_product || user.is_admin)
        children.push({ key: "/products", icon: <FaWarehouse style={iconStyle} />, label: t("header.products"), onClick: nav("/products") });
      if (integrationConfig?.enableSync)
        children.push({ key: "/products/integrated", icon: <FaWarehouse style={iconStyle} />, label: "Integrated Products", onClick: nav("/products/integrated") });
      if (permission.view_category || user.is_admin)
        children.push({ key: "/category", icon: <BiCategoryAlt style={iconStyle} />, label: t("header.product_category"), onClick: nav("/category") });
      items.push({ key: "productDropdown", icon: <FaWarehouse style={iconStyle} />, label: t("header.product"), children });
    }

    if (permission.view_customer_invoice || permission.view_saved_customer_invoice || permission.view_fund || user.is_admin) {
      const children = [];
      if (permission.view_customer_invoice || user.is_admin)
        children.push({ key: "/invoice/add_invoice", icon: <VscNewFile style={iconStyle} />, label: t("header.add_order"), onClick: nav("/invoice/add_invoice") });
      if (permission.view_saved_customer_invoice || user.is_admin)
        children.push({ key: "/invoice/view_invoices", icon: <FaWarehouse style={iconStyle} />, label: t("header.view_order"), onClick: nav("/invoice/view_invoices") });
      if (permission.view_fund || user.is_admin)
        children.push({ key: "/invoice/view_fund", icon: <RiRefund2Line style={iconStyle} />, label: t("header.view_fund"), onClick: nav("/invoice/view_fund") });
      if (permission.view_online_order || user.is_admin)
        children.push({ key: "/invoice/online_order", icon: <RiRefund2Line style={iconStyle} />, label: t("header.online_orders"), onClick: nav("/invoice/online_order") });
      if (user.is_admin && integrationConfig?.enableSync)
        children.push({ key: "/invoice/website_order", icon: <RiRefund2Line style={iconStyle} />, label: t("header.website_orders"), onClick: nav("/invoice/website_order") });
      items.push({ key: "orderDropdown", icon: <FaFileInvoiceDollar style={iconStyle} />, label: t("header.orders"), children });
    }

    if (permission.view_employee || permission.view_department || user.is_admin) {
      const children = [];
      if (permission.view_employee || user.is_admin)
        children.push({ key: "/admin/employee", icon: <FaUserAlt style={iconStyle} />, label: t("header.employee"), onClick: nav("/admin/employee") });
      if (permission.view_department || user.is_admin)
        children.push({ key: "/admin/view_department", icon: <FaBuilding style={iconStyle} />, label: t("header.department"), onClick: nav("/admin/view_department") });
      if (permission.add_department_invoice || user.is_admin)
        children.push({ key: "/admin/department/new_order", icon: <HiDocumentAdd style={iconStyle} />, label: t("header.new_order"), onClick: nav("/admin/department/new_order") });
      if (permission.view_department_invoice || user.is_admin)
        children.push({ key: "/admin/department/view_order", icon: <FaFileInvoiceDollar style={iconStyle} />, label: t("header.view_order"), onClick: nav("/admin/department/view_order") });
      if (permission.view_department_debt || user.is_admin)
        children.push({ key: "/admin/department/view_debt", icon: <FaMoneyCheck style={iconStyle} />, label: t("header.view_department_debt"), onClick: nav("/admin/department/view_debt") });
      items.push({ key: "departmentDropdown", icon: <FaBuilding style={iconStyle} />, label: t("header.department"), children });
    }

    if (permission.view_open_fund || user.is_admin) {
      const children = [];
      if (permission.view_open_fund || user.is_admin)
        children.push({ key: "/fund/open_fund", icon: <FaUserAlt style={iconStyle} />, label: t("header.open_fund"), onClick: nav("/fund/open_fund") });
      if (permission.transfer_fund || user.is_admin) {
        children.push({ key: "/admin/settings/box/transfer", icon: <RiRefund2Line style={iconStyle} />, label: t("box.transfer_funds"), onClick: nav("/admin/settings/box/transfer") });
        children.push({ key: "/admin/settings/box/transfer/history", icon: <HiDocumentText style={iconStyle} />, label: t("box.transfer_history"), onClick: nav("/admin/settings/box/transfer/history") });
      }
      items.push({ key: "fundDropdown", icon: <FaMoneyBillWave style={iconStyle} />, label: t("header.fund"), children });
    }

    {
      const children = [];
      if (permission.view_application_setting || user.is_admin)
        children.push({ key: "/setting", icon: <AiFillSetting style={iconStyle} />, label: t("header.app_setting"), onClick: nav("/setting") });
      if (user.is_admin) {
        children.push({ key: "/admin/settings/admin_settings", icon: <MdSettings style={iconStyle} />, label: t("header.setting"), onClick: nav("/admin/settings/admin_settings") });
        children.push({ key: "/admin/settings/position", icon: <RiFolderUserFill style={iconStyle} />, label: t("header.employee_position"), onClick: nav("/admin/settings/position") });
        children.push({ key: "/admin/settings/permission", icon: <FaLock style={iconStyle} />, label: t("header.permission"), onClick: nav("/admin/settings/permission") });
        children.push({ key: "/admin/settings/permission_category", icon: <RiFolderLockFill style={iconStyle} />, label: t("header.permission_category"), onClick: nav("/admin/settings/permission_category") });
        if (user.is_admin || permission.view_role)
          children.push({ key: "/admin/settings/roles", icon: <FaUserLock style={iconStyle} />, label: t("header.roles"), onClick: nav("/admin/settings/roles") });
        if (user.is_admin || permission.view_box)
          children.push({ key: "/admin/settings/box", icon: <FaWarehouse style={iconStyle} />, label: t("header.box"), onClick: nav("/admin/settings/box") });
        children.push({ key: "/admin/settings/audit_logs", icon: <FaList style={iconStyle} />, label: t("header.audit_logs"), onClick: nav("/admin/settings/audit_logs") });
        children.push({ key: "/admin/settings/invoice_template", icon: <FaFileInvoiceDollar style={iconStyle} />, label: t("department.invoice.template_settings"), onClick: nav("/admin/settings/invoice_template") });
      }
      if (children.length > 0)
        items.push({ key: "adminSettingDropdown", icon: <MdSettings style={iconStyle} />, label: t("header.settings"), children });
    }

    if (permission.view_customer || permission.view_customer_debt || user.is_admin) {
      const children = [];
      if (permission.view_customer || user.is_admin)
        children.push({ key: "/customer/view", icon: <FaUserTie style={iconStyle} />, label: t("header.customer_view"), onClick: nav("/customer/view") });
      if (permission.view_customer_debt || user.is_admin)
        children.push({ key: "/customer/debt", icon: <FaMoneyBillWave style={iconStyle} />, label: t("header.customer_debt"), onClick: nav("/customer/debt") });
      items.push({ key: "customerDropdown", icon: <MdPeopleAlt style={iconStyle} />, label: t("header.customers"), children });
    }

    if (permission.view_supplier || permission.view_supplier_invoice || user.is_admin) {
      const children = [];
      if (permission.view_supplier || user.is_admin)
        children.push({ key: "/supplier/view", icon: <IoIosPeople style={iconStyle} />, label: t("header.suppliers_view"), onClick: nav("/supplier/view") });
      if (permission.view_supplier_invoice || user.is_admin)
        children.push({ key: "/supplier/invoice", icon: <FaFileInvoiceDollar style={iconStyle} />, label: t("header.suppliers_invoice"), onClick: nav("/supplier/invoice") });
      if (permission.view_saved_supplier_invoice || user.is_admin)
        children.push({ key: "/supplier/view_invoice", icon: <AiFillFile style={iconStyle} />, label: t("header.suppliers_view_invoice"), onClick: nav("/supplier/view_invoice") });
      items.push({ key: "supplierDropdown", icon: <IoIosPeople style={iconStyle} />, label: t("header.suppliers"), children });
    }

    if (permission.inventory_summery || permission.product_summery || permission.employee_summery || permission.inventory_product || user.is_admin) {
      const children = [];
      if (permission.inventory_summery || user.is_admin)
        children.push({ key: "/inventory/summery", icon: <HiChartBar style={iconStyle} />, label: t("header.inventory_summery"), onClick: nav("/inventory/summery") });
      if (permission.product_summery || user.is_admin)
        children.push({ key: "/inventory/stat", icon: <HiChartPie style={iconStyle} />, label: t("header.product_summery"), onClick: nav("/inventory/stat") });
      if (permission.employee_summery || user.is_admin)
        children.push({ key: "/inventory/summeryEmp", icon: <FaChartLine style={iconStyle} />, label: t("header.employee_summery"), onClick: nav("/inventory/summeryEmp") });
      if (permission.inventory_product || user.is_admin)
        children.push({ key: "/inventory/product", icon: <MdOutlineInventory style={iconStyle} />, label: t("header.inventory_product"), onClick: nav("/inventory/product") });
      items.push({ key: "summeriesDropdown", icon: <HiChartBar style={iconStyle} />, label: t("header.summeries"), children });
    }

    if (permission.view_charges || user.is_admin) {
      const children = [];
      if (permission.view_charges || user.is_admin)
        children.push({ key: "/charges", icon: <GiPayMoney style={iconStyle} />, label: t("header.charges"), onClick: nav("/charges") });
      if (user.is_admin) {
        children.push({ key: "/admin/settings/print_setting", icon: <TbFileBarcode style={iconStyle} />, label: t("header.print_setting"), onClick: nav("/admin/settings/print_setting") });
        children.push({ key: "/reports/daily", icon: <HiDocumentText style={iconStyle} />, label: "Daily Report", onClick: nav("/reports/daily") });
      }
      items.push({ key: "otherDropdown", icon: <GiPayMoney style={iconStyle} />, label: t("header.others"), children });
    }

    if (permission.view_whatsapp || permission.view_whatsapp_settings || permission.view_whatsapp_queue || user.is_admin) {
      const children = [];
      if (permission.view_whatsapp || user.is_admin)
        children.push({ key: "/whatsapp/whatsapp_product", icon: <FaWhatsapp style={iconStyle} />, label: t("header.whatsapp_product"), onClick: nav("/whatsapp/whatsapp_product") });
      if (permission.view_whatsapp_queue || user.is_admin)
        children.push({ key: "/whatsapp/whatsapp_queue", icon: <FaList style={iconStyle} />, label: t("header.whatsapp_queue"), onClick: nav("/whatsapp/whatsapp_queue") });
      if (permission.view_whatsapp_settings || user.is_admin)
        children.push({ key: "/whatsapp/whatsapp_settings", icon: <FaWhatsapp style={iconStyle} />, label: t("header.whatsapp_settings"), onClick: nav("/whatsapp/whatsapp_settings") });
      items.push({ key: "whatsappDropdown", icon: <FaWhatsapp style={iconStyle} />, label: t("header.whatsapp"), children });
    }

    return items;
  }, [t, permission, user, integrationConfig]);

  return (
    <div>
      {logoImage && (
        <div className="text-center py-3" style={{ backgroundColor: "#542643" }}>
          <img
            src={logoImage}
            alt="logo"
            style={{ maxWidth: "80%", maxHeight: 80, objectFit: "contain" }}
          />
        </div>
      )}
      <Menu
        mode="inline"
        items={menuItems}
        selectedKeys={[location.pathname]}
        defaultOpenKeys={[]}
        style={{ borderInlineEnd: "none" }}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  permission: state.appPermissions.permission || {},
  user: state.appPermissions.user || {},
  integrationConfig: state.appSetting.integrationConfig,
});

export default connect(mapStateToProps)(MobileMenu);
